<div class="verify-page d-flex align-items-center justify-content-center">
    <div class="verify-card p-5 shadow bg-white text-center">
        <div class="branding mb-4 d-flex align-items-center justify-content-center">
            <svg width="32" height="32" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="me-2">
                <path d="M20 2L35.5885 11V29L20 38L4.41154 29V11L20 2Z" stroke="#0c1427" stroke-width="2.5"/>
                <circle cx="20" cy="20" r="4" fill="#d59448"/>
            </svg>
            <h4 class="m-0 fw-bold brand-text">SUPPLY<span class="text-gold">VALID</span></h4>
        </div>

        <div *ngIf="loading" class="py-4">
            <p-progressSpinner styleClass="custom-spinner" strokeWidth="4"></p-progressSpinner>
            <p class="mt-3 text-muted">Verifying your email address...</p>
        </div>

        <div *ngIf="!loading && success">
            <i class="pi pi-check-circle text-success mb-3" style="font-size: 4rem"></i>
            <h2 class="fw-bold text-dark">Email Verified!</h2>
            <p class="text-muted mb-4">Your email has been successfully verified. You can now proceed to log in.</p>
            <button pButton label="Back to Login" icon="pi pi-arrow-left" [routerLink]="['/login']" class="p-button-primary rounded-0 px-4"></button>
        </div>

        <div *ngIf="!loading && error">
            <i class="pi pi-times-circle text-danger mb-3" style="font-size: 4rem"></i>
            <h2 class="fw-bold text-dark">Verification Failed</h2>
            <p class="text-muted mb-4">{{ error }}</p>
            <div class="d-flex gap-2 justify-content-center">
                <button pButton label="Retry" icon="pi pi-refresh" (click)="verify()" class="p-button-secondary p-button-outlined rounded-0"></button>
                <button pButton label="Back to Login" [routerLink]="['/login']" class="p-button-link text-decoration-none"></button>
            </div>
        </div>
    </div>
</div>
